(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodGaEvent', sodGaEvent);

    function sodGaEvent(GaService) {
        return {
            restrict: 'A',
            scope: {
                sodGaEvent: '=',
                gaModel: '=?',
            },
            link: function(scope, elem, attrs) {
                if (!gtag) return;
                elem.on('click', function(e) {
                    GaService.addEvent(scope.sodGaEvent, scope.gaModel);
                });
            }
        };
    }
})();